import { render, staticRenderFns } from "./NuevaNotaEnfermeria.vue?vue&type=template&id=134aa38f&scoped=true"
import script from "./NuevaNotaEnfermeria.vue?vue&type=script&lang=js"
export * from "./NuevaNotaEnfermeria.vue?vue&type=script&lang=js"
import style0 from "./NuevaNotaEnfermeria.vue?vue&type=style&index=0&id=134aa38f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134aa38f",
  null
  
)

export default component.exports